<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户账户管理'}, {label: '交易记录'}]"/>
    <el-form label-width="170px" class="xzformitemmb">
      <el-row>
        <panel title="客户信息" border>
          <el-col :span="12">
            <el-form-item label="客户编号 ：">
              {{customerDetailData.c__customerCode}}
            </el-form-item>
            <el-form-item label="客户姓名 ：">
              {{customerDetailData.c__customerName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别 ：">
              {{customerDetailData.i__contactSex|sex2CN }}
            </el-form-item>
            <el-form-item label="身份证号码 ：">
              {{customerDetailData.i__bizrepIC}}
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>
    <panel title="交易记录">
    <div title="" class="bg-purple xzpadd10">
      <data-table
        :tableData="CustomerCashJournalListData"
        :columns="CustomerCashJournalListColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters.sync="filters"
      ></data-table>
    </div>
    </panel>
    <button-back></button-back>
  </div>
</template>

<script>
  import sexOptions from '../../../utils/sexOptions'
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions"
  import Panel from "../../../components/Panel"
  import ButtonBack from "../../../components/ButtonBack";
  import {formatMoney} from "../../../filters/CommonFilters";
    export default {
        name: "CashJournalList",
        data() {
          return {
            page: 1,
            pageSize: 10,
            CustomerCashJournalListData: {},
            customerDetailData:{
            },
            customerId:this.$route.query['c.customerId'],
            CustomerCashJournalListColumns: [
              {
                name: '分类',
                field: 'cj__referenceType',
                formatter: function (r,c,v) {
                  return Status2CN(r.cj__referenceType)
                }
              },
              {
                name: '时间',
                field: 'cj__postingDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD hh:mm')
                }
              },
              {
                name: '名称',
                field: 'cj__channel'
              },
              {
                name: '交易号',
                field: 'cj__reference'
              },
              {
                name: '金额',
                field: 'cj__postingAmount',
                formatter:  (r,c,v)=> {
                  return formatMoney(v)+'元'
                }
              },
              {
                name: '摘要',
                field: 'cj__remarks'
              }
            ],
            filters: {
              form: {
                c__customerId: '',
                c__customerName: '',
                i__socialIdentityCode: '',
                cj__postingDate: [],
                cj__referenceType:''
              },
              columns: [
                {
                  label: '时间',
                  component: 'date-range-picker',
                  field: 'cj__postingDate',
                  op:['gteq','lteq']
                },
                {
                  label: '分类',
                  component: 'el-select',
                  field: 'cj__referenceType',
                  op:'eq',
                  options: [
                    {
                      label: '提款',
                      value: 'PAY'
                    },
                    {
                      label: '还款',
                      value: 'REPAY'
                    }
                  ]
                }
              ],
              onSubmit:()=>{
                this.page = 1
                this.getCustomerCashJournalList(this.customerId)
                this.getCustomerDetail(this.customerId)
              }
            }
          }
        },
        computed : {
          filterParams: {
            get: function() {
              return {
                pageSize: this.pageSize,
                pageOffset: (this.page - 1) * this.pageSize,
                'xlist.sort.dataField': 'cj.postingDate',
                'xlist.sort.order': 'desc'
              }
            },
            set:function (newVal) {

            }
          }
        },
        watch: {
          filterParams: function () {
            this.getCustomerCashJournalList(this.customerId)
            this.getCustomerDetail(this.customerId)
          }
        },
        mounted() {
          this.getCustomerCashJournalList(this.customerId)
          this.getCustomerDetail(this.customerId)
        },
        components: {
          ButtonBack,
          Panel
        },
        filters:{
          sex2CN: function (sex) {
            let sexItem = sexOptions.filter(item=>item.value == sex).shift()||[]
            return sexItem.label||''
          }
        },
        methods: {
          getCustomerCashJournalList: function (customerId = this.customerId ) {
            xhr.getCustomerCashJournalList(
              Object.assign({},
                {
                  pageSize: this.pageSize,
                  pageOffset: (this.page - 1) * this.pageSize,
                  'xlist.search.cj.customerId': customerId,
                  'xlist.search.cj.customerId.op': 'eq'
                },
                this.filterParams, xmlBuildQuery(this.filters)),

              res=> {
                try {
                  this.CustomerCashJournalListData = res.data
                }catch(e){

                }
              })

          },
          getCustomerDetail : function (customerId = this.customerId ) {
            xhr.getCustomerDetail(

                {
                  'c.customerId': customerId
                },

              res=> {
                try {
                  this.customerDetailData = res.data.data
                }catch(e){

                }
              })
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/CashJournalList.vue